import React, { useState } from "react";
import styles from "./index.module.scss";
import { Link } from "react-router-dom";
import { Button } from "../../../login/components";

// const sides = [1, 4, 6, 3];

export interface RollButtonProps {
  roll: () => void;
  //   increase: (inc: number) => void;
  //   rolled?: number;
  //   setRolled?: (num: any) => void;
}

function RollButton({ roll }: RollButtonProps) {
  const [showPopup, setShowPopup] = useState(false);
  const [video, setVideo] = useState(false);
  //   const [_rolled, setRolled] = useState(sides[0]);
  //   const [annimate, setAnnimate] = useState(false);

  return (
    <>
      {showPopup && (
        <div className={styles.popup}>
          <div onClick={() => setShowPopup(false)}>Close</div>
          <div className={styles.rule}>
            <h1>Rules</h1>
            <Button
              name={video ? "Text" : "Video"}
              onClick={() => setVideo(!video)}
            />
            <br />
            {video && (
              <video
                controls
                src="https://res.cloudinary.com/dxuiu1h8i/video/upload/v1624516858/pachasi/WhatsApp_Video_2021-06-24_at_10.49.00_j7hwga.mp4"
              ></video>
            )}
            {!video && (
              <>
                <p>
                  1. As soon as the player enters the game, questions pop up in
                  the screen.
                </p>
                <p>
                  2. If the player answers it correctly, one point gets added to
                  the streak of the player. The questions get progressively
                  harder with every question the user answers correctly.
                </p>
                <p>
                  3. If the player gets it wrong, then the streak of the player
                  will be the rolled dice number. After the roll, the turn
                  shifts to the other players / bots in the game room.
                </p>
                <p>
                  4. A short animated clip pertaining to the incorrectly
                  answered question will also be played before the roll.
                </p>
                <br />
                <br />
                <p> ★ To move 5 steps ahead</p>
                <p> ✹ Bonus question to move 3 steps ahead</p>
                <p> ✦ Bonus question to move 10 steps ahead if Right</p>
                <p> ✧ To move 4 steps back</p>
              </>
            )}
          </div>
        </div>
      )}
      <div className={styles.leaderboard}>
        <Link to="leaderboard">
          <button className={styles.rollDice}>Leaderboard</button>
        </Link>
      </div>
      <div className={styles.roll}>
        <button
          className={styles.rollDice}
          onClick={() => {
            roll();
            //   const diceNumber = sides[Math.floor(Math.random() * sides.length)];
            //   //   setRolled(diceNumber);
            //   setAnnimate(true);
            //   setTimeout(() => {
            //     increase(diceNumber);
            //   }, 2000);
          }}
        >
          Roll The Dice
        </button>
        <button
          className={styles.rollDice1}
          onClick={() => {
            setShowPopup(true);
            // roll();
            //   const diceNumber = sides[Math.floor(Math.random() * sides.length)];
            //   //   setRolled(diceNumber);
            //   setAnnimate(true);
            //   setTimeout(() => {
            //     increase(diceNumber);
            //   }, 2000);
          }}
        >
          Rules
        </button>
      </div>
    </>
  );
}

export default RollButton;
